import gql from "graphql-tag";
import actionFormContainer from "../../clientDispatches/forms/actionFormContainer";
import {cancelPlacePurchaseOrder, successPlacePurchaseOrder} from "../../../actions/PurchaseOrderApiActions";

export default actionFormContainer({
  mutation: gql`
    mutation placePurchaseOrder($data: PurchaseOrderIdInput!) {
      placePurchaseOrder(input: $data) {
        errors { key message }
      }
    }
  `,
  resultField: "placePurchaseOrder",
  buildData: (props) => ({purchaseOrderId: props.purchaseOrderId}),
  formProps: () => ({
    submitLabel: "Place Order",
    message: "Mark this order as placed with the supplier? Its lines then show as incoming stock at the destination, and they can no longer be changed.",
  }),
  success: successPlacePurchaseOrder,
  cancel: cancelPlacePurchaseOrder,
});
